<template>
    <router-link
        class="Nav-Link"
        :to="route"
        @click.native="$emit('click')"
        v-tooltip="isCollapsed && tooltip ? tooltip : ''"
    >
        <i :class="icon"></i>
        <span>{{ displayLabel }}</span>
    </router-link>
</template>

<script>
export default {
    name: 'NavLink',
    props: {
        route: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        collapsedLabel: {
            type: String,
            default: '',
        },
        tooltip: {
            type: String,
            default: '',
        },
        isCollapsed: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        displayLabel() {
            if (this.isCollapsed && this.collapsedLabel) {
                return this.collapsedLabel;
            }
            return this.label;
        },
    },
};
</script>
